export const RESUME_ADDITIONAL_EDIT_MODAL_NAME = 'resumeAdditionalEdit';
